import React, { useEffect } from "react";
import { connect } from "react-redux";
import Layout from "components/layout";
import { bindActionCreators } from "redux";
import { Creators as LocationActions } from "store/location/location-duck";
import { Creators as UserSessionActions } from "store/user-session/user-session-duck";
import { IUserData } from "store/user-session/user-session-model";
import { Creators as UsersActions } from "store/users/users-duck";
import { IItems } from "store/users/users-model";
import useTranslation from "utils/hooks/useTranslation";
import UsersFilter from "./filter/";
import UsersGrid from "./grid/";
import * as S from "./styled/index.styled";

interface IPropsScreenUsers {
  isLoading?: boolean;
  items?: Array<IItems>;
  totalItems?: number;
  searchFilter?: string;
  editActive?: boolean;
  pageIndex?: number;
  userData?: IUserData;
  isLoadingTable?: boolean;
}
interface IDispatchProps {
  usersFetchAsync?: (...args) => void;
  usersChangeFieldValue?: (...args) => void;
  usersFetchByIdAsync?: (...args) => void;
  usersUpdateFilter?: (...args) => void;
  usersEditActive?: (...args) => void;
  usersUpdateFormModified?: (...args) => void;
  usersRolesFetchAsync?: (...args) => void;
  usersClearFilterTable?: (...args) => void;
  locationActiveFetchAsync?: (...args) => void;
  userSessionMenuItemActive?: (...args) => void;
}

type IProps = IPropsScreenUsers & IDispatchProps;

const Users = ({
  isLoading,
  isLoadingTable,
  items,
  totalItems,
  searchFilter,
  editActive,
  pageIndex,
  userData,
  usersFetchAsync,
  usersChangeFieldValue,
  usersUpdateFilter,
  usersFetchByIdAsync,
  usersEditActive,
  usersUpdateFormModified,
  usersRolesFetchAsync,
  usersClearFilterTable,
  locationActiveFetchAsync,
  userSessionMenuItemActive,
}: IProps) => {
  const TITLE_PAGE_REGISTRATION = useTranslation({ id: "user" });

  useEffect(() => {
    return () => {
      usersUpdateFilter(null);
    };
  }, []);

  return (
    <Layout title={TITLE_PAGE_REGISTRATION} isLoading={isLoading} role={userData.role}>
      <S.HeaderContainer>
        <S.SearchInput>
          <UsersFilter usersUpdateFilter={usersUpdateFilter} usersChangeFieldValue={usersChangeFieldValue} />
        </S.SearchInput>
      </S.HeaderContainer>
      <UsersGrid
        usersFetchAsync={usersFetchAsync}
        usersChangeFieldValue={usersChangeFieldValue}
        items={items}
        totalItems={totalItems}
        searchFilter={searchFilter}
        usersFetchByIdAsync={usersFetchByIdAsync}
        editActive={editActive}
        usersClearFilterTable={usersClearFilterTable}
        usersEditActive={usersEditActive}
        usersUpdateFormModified={usersUpdateFormModified}
        pageIndex={pageIndex}
        usersRolesFetchAsync={usersRolesFetchAsync}
        locationActiveFetchAsync={locationActiveFetchAsync}
        isLoadingTable={isLoadingTable}
        userSessionMenuItemActive={userSessionMenuItemActive}
      />
    </Layout>
  );
};

const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...UsersActions, ...LocationActions, ...UserSessionActions }, dispatch);

const mapStateToProps = (state) => ({
  isLoading: state.Users.isLoading,
  items: state.Users.items,
  totalItems: state.Users.totalItems,
  searchFilter: state.Users.searchFilter,
  editActive: state.Users.editActive,
  pageIndex: state.Users.filter.pageIndex,
  userData: state.UserSession.userData,
  isLoadingTable: state.Users.isLoadingTable,
});

export default connect(mapStateToProps, mapDispatchToActions)(Users);
